import React from "react";
import Homepage from "./views/homepage";

const App = () => {
  return(
      <Homepage/>
    );
}

export default App;